import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIMultiColumn from 'UIComponents/layout/UIMultiColumn';
import UIMultiColumnGroup from 'UIComponents/layout/UIMultiColumnGroup';
import UIMultiColumnItem from 'UIComponents/layout/UIMultiColumnItem';
import { EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CurrentlyScheduledCardInfo = ({
  actionTypeBodyInfoKey,
  dateTimeCopyOptions,
  onReschedulingClick,
  openCancelScheduleConfirmModal
}) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(UIMultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(UIMultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(UIMultiColumnItem, {
          horizontalAlign: "left",
          verticalAlign: "middle",
          className: "p-x-2",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `baseSchedulingOptionsModal.body.currentlyScheduledInfo.${actionTypeBodyInfoKey}`,
            options: dateTimeCopyOptions
          })
        }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
          horizontalAlign: "right",
          verticalAlign: "middle",
          className: "p-x-2",
          children: /*#__PURE__*/_jsx(UIIconButton, {
            use: "unstyled",
            onClick: onReschedulingClick,
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "edit",
              color: EERIE
            })
          })
        }), /*#__PURE__*/_jsx(UIMultiColumnItem, {
          horizontalAlign: "right",
          verticalAlign: "middle",
          className: "p-x-2",
          children: /*#__PURE__*/_jsx(UIIconButton, {
            use: "unstyled",
            onClick: () => openCancelScheduleConfirmModal(actionTypeBodyInfoKey),
            children: /*#__PURE__*/_jsx(UIIcon, {
              name: "delete",
              color: EERIE
            })
          })
        })]
      })
    })
  });
};
export default CurrentlyScheduledCardInfo;